export default __webpack_public_path__ + "static/media/401.61952601.svg";